import { parseLeadFields } from './parseLeadFields'
import { Lead } from './types'

const baseURL = process.env.NEXT_PUBLIC_LEADS_API_HOST

type LeadResponse = {
  id: string
}

const commonHeaders = {
  'x-realm': 'ton',
  'Content-Type': 'application/json'
}

const createLead = async () => {
  let data: LeadResponse
  const config: RequestInit = {
    method: 'POST',
    headers: commonHeaders,
    body: JSON.stringify({}) // don't remove this, the endpoint expects some body
  }

  const res = await fetch(`${baseURL}/v1/`, config)

  try {
    data = await res.json()
  } catch {
    throw new Error('Error at lead request')
  }

  return data
}

const updateLead = async (id: string, fields: Lead) => {
  const body = parseLeadFields(fields)

  const config: RequestInit = {
    method: 'PUT',
    headers: commonHeaders,
    body: JSON.stringify(body)
  }

  await fetch(`${baseURL}/v1/${id}`, config)
}

const checkExists = async (email: string) => {
  const config: RequestInit = {
    method: 'POST',
    headers: commonHeaders,
    body: JSON.stringify({
      login: email
    })
  }

  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_REACT_APP_API_HOST_SMUSER}/users/check-exists`,
      config
    )

    return {
      success: true,
      status: response.status,
      data: response.body
    }
  } catch (error) {
    return {
      success: false,
      status: (error as { status: number }).status,
      errors: error
    }
  }
}

const tonLeadService = { createLead, updateLead, checkExists }

export default tonLeadService
